<template>
  <v-container>
    <app-navigation></app-navigation>
    <v-main class="pt-12">
      <div class="pt-md-5">
        <v-layout align-center justify-center row wrap>
          <v-flex xs12 class="mx-1 mb-1 pa-0">
            <main-sub-page-toolbar icon="mdi-poll">{{
              $t("dashboardCardSuperAdminAppStatistics")
            }}</main-sub-page-toolbar>
          </v-flex>
          <v-flex xs12 class="mx-1 mb-1 pa-0 animated fadeIn">
            <v-card
              class="#505050--text mb-12"
              :class="
                getTheme() == 'dark'
                  ? 'outlined elevation-0'
                  : 'flat elevation-0'
              "
              :style="
                getTheme() == 'dark'
                  ? 'border: 1px solid darkgray; background-color: whitesmoke'
                  : 'border: none; background-color: white'
              "
            >
              <v-card-text
                class="d-flex overline align-center justify-center ma-0 pa-0 pt-2"
              >
                <v-spacer></v-spacer>
                <div class="d-flex flex-wrap justify-center">
                  <v-btn
                    small
                    fab
                    color="primary"
                    class="elevation-0 mr-2"
                    @click="changeView(-1)"
                  >
                    <v-icon>mdi-arrow-left-bold-circle</v-icon>
                  </v-btn>
                </div>
                <v-spacer></v-spacer>
                <div class="d-flex flex-wrap justify-center">
                  {{ $t("statsTotalSum") }}:
                  {{
                    $store.state.storeOrderDayFull.orderStatsMonthSum
                      .totalSumCart
                  }}
                  {{
                    $store.state.storeClient.client.environmentSettings.currency
                  }}
                  /
                  {{
                    $store.state.storeOrderDayFull.orderStatsMonthSum.orderNum
                  }}
                  {{ $t("statsOrderNumTitle") }}
                </div>
                <v-spacer></v-spacer>
                <div class="d-flex flex-wrap justify-center">
                  <v-btn
                    small
                    fab
                    color="primary"
                    class="elevation-0"
                    @click="changeView(1)"
                  >
                    <v-icon>mdi-arrow-right-bold-circle</v-icon>
                  </v-btn>
                </div>
                <v-spacer></v-spacer>
              </v-card-text>

              <v-card-text
                class="title font-weight-regular pa-2 justify-center align-center"
              >
                <v-spacer></v-spacer>
                <div class="d-flex flex-wrap justify-center">
                  <v-select
                    style="height: 35px; max-width: 150px"
                    dense
                    outlined
                    v-model="cMode"
                    :items="cModeType"
                    item-text="title"
                    item-value="query"
                    :label="$t('statsModeTitle')"
                    @change="selectMode()"
                    class="mr-2 mb-3"
                  ></v-select>
                  <v-select
                    style="height: 35px; max-width: 250px"
                    dense
                    outlined
                    v-show="cMode == 'day'"
                    v-model="dayView.month"
                    :items="monthsType"
                    item-text="title"
                    item-value="query"
                    :label="$t('monthStr')"
                    @change="selectView()"
                    class="mr-2 mb-3"
                  ></v-select>
                  <v-select
                    style="height: 35px; max-width: 100px"
                    dense
                    outlined
                    class="mr-2 mb-3"
                    v-show="cMode == 'day' || cMode == 'month'"
                    v-model="dayView.year"
                    :items="yearsType"
                    item-text="query"
                    item-value="query"
                    :label="$t('yearStr')"
                    @change="selectView()"
                  ></v-select>
                </div>
                <v-spacer></v-spacer>
              </v-card-text>

              <v-card-text
                class="d-flex align-center justify-center ma-0 pa-0"
                id="chartSizer"
              >
                <apexchart
                  ref="statsChart"
                  :width="getSizerWidth"
                  :options="chartOptions"
                  :series="$store.state.storeOrderDayFull.orderStats"
                ></apexchart>
              </v-card-text>
              <v-card-title class="d-flex"
                >{{ $t("statsSummaryTitle") }}
                <span
                  style="margin-left: 8px; margin-right: 4px"
                  v-if="this.cMode == 'day'"
                  >{{ monthsType[dayView.month].title }} /</span
                >
                {{ dayView.year }}</v-card-title
              >
              <v-card-text>
                <div class="overline mb-2">
                  {{ $t("statsTotalSum") }}:
                  {{
                    $store.state.storeOrderDayFull.orderStatsMonthSum
                      .totalSumCart
                  }}
                  {{
                    $store.state.storeClient.client.environmentSettings.currency
                  }}
                  /
                  {{
                    $store.state.storeOrderDayFull.orderStatsMonthSum.orderNum
                  }}
                  {{ $t("statsOrderNumTitle") }}
                </div>
                <div>
                  {{ $t("statsDevelopImagesTitle") }}:
                  {{
                    $store.state.storeOrderDayFull.orderStatsMonthSum
                      .totalCopiesSum
                  }}
                  {{
                    $store.state.storeClient.client.environmentSettings.currency
                  }}
                  /
                  {{
                    $store.state.storeOrderDayFull.orderStatsMonthSum
                      .totalCopies
                  }}
                  {{ $t("lmPcs") }}
                </div>
                <div>
                  {{ $t("statsPhotoItemsTitle") }}:
                  {{
                    $store.state.storeOrderDayFull.orderStatsMonthSum
                      .itemCopiesSum
                  }}
                  {{
                    $store.state.storeClient.client.environmentSettings.currency
                  }}
                  /
                  {{
                    $store.state.storeOrderDayFull.orderStatsMonthSum.itemCopies
                  }}
                  {{ $t("lmPcs") }}
                </div>
                <div>
                  {{ $t("statsExtraCostsTitle") }}:
                  {{
                    $store.state.storeOrderDayFull.orderStatsMonthSum
                      .extraCostsSum
                  }}
                  {{
                    $store.state.storeClient.client.environmentSettings.currency
                  }}
                </div>

                <div class="mt-4">
                  {{ $t("statsOrderNumCompany") }}:
                  {{
                    $store.state.storeOrderDayFull.orderStatsMonthSum
                      .orderNumCompany
                  }}
                </div>
                <div>
                  {{ $t("statsOrderNumPaymentCard") }}:
                  {{
                    $store.state.storeOrderDayFull.orderStatsMonthSum
                      .orderNumPaymentCard
                  }}
                </div>
                <div>
                  {{ $t("statsOrderNumPaymentDelivery") }}:
                  {{
                    $store.state.storeOrderDayFull.orderStatsMonthSum
                      .orderNumPaymentDelivery
                  }}
                </div>
                <div>
                  {{ $t("statsOrderNumPaymentPersonal") }}:
                  {{
                    $store.state.storeOrderDayFull.orderStatsMonthSum
                      .orderNumPaymentPersonal
                  }}
                </div>
                <div>
                  {{ $t("statsOrderNumPaymentPrepay") }}:
                  {{
                    $store.state.storeOrderDayFull.orderStatsMonthSum
                      .orderNumPaymentPrepay
                  }}
                </div>
                <div>
                  {{ $t("statsOrderNumPost") }}:
                  {{
                    $store.state.storeOrderDayFull.orderStatsMonthSum
                      .orderNumPost
                  }}
                </div>
                <div>
                  {{ $t("statsOrderNumPromoCode") }}:
                  {{
                    $store.state.storeOrderDayFull.orderStatsMonthSum
                      .orderNumPromoCode
                  }}
                </div>
              </v-card-text>
            </v-card>
          </v-flex>
          <simple-navigation-button
            left
            :title="$t('lmBtnBack')"
            icon="mdi-arrow-left"
            @clicked="$router.push({ name: 'home' })"
          ></simple-navigation-button>
        </v-layout>
      </div>
    </v-main>
  </v-container>
</template>

<script>
import Vue from "vue";
import VueApexCharts from "vue-apexcharts";
Vue.use(VueApexCharts);
Vue.component("apexchart", VueApexCharts);

import AppNavigation from "@/views/AppNavigation";
import MainSubPageToolbar from "@/components/MainSubPageToolbar";
import SimpleNavigationButton from "@/components/SimpleNavigationButton";
import store from "@/store";
let chartLocale = require("apexcharts/dist/locales/" +
  store.state.storeClient.client.environmentSettings.lang +
  ".json");

export default {
  name: "userImagePrices",
  components: {
    AppNavigation,
    MainSubPageToolbar,
    SimpleNavigationButton,
  },
  data: function () {
    return {
      cMode: "day",
      dayView: {
        year: new Date().getFullYear(),
        month: new Date().getMonth(),
        from: new Date(),
        to: new Date(),
      },
      yearsType: [{ query: 2020 }],
      chartOptions: {
        chart: {
          id: "myStats",
          type: "bar",
          toolbar: {
            show: false,
          },
          stacked: true,
          locales: [chartLocale],
          defaultLocale: this.$store.state.storeClient.client
            .environmentSettings.lang,
        },
        plotOptions: {
          bar: {
            horizontal: false,
          },
        },
        yaxis: {
          title: {
            text: this.$store.state.storeClient.client.environmentSettings
              .currency,
          },
        },
        xaxis: {
          type: "datetime",
          labels: {
            format: "dd",
          },
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "light",
            type: "horizontal",
            shadeIntensity: 0.15,
            gradientToColors: undefined,
            inverseColors: true,
            opacityFrom: 0.92,
            opacityTo: 0.92,
            stops: [50, 0, 100],
          },
        },
        dataLabels: {
          enabled: false,
        },
        colors: ["#009900", "#006699", "#CC0000"],
      },
      cModeType: [
        {
          title: this.$t("statsModeDay"),
          query: "day",
        },
        {
          title: this.$t("statsModeMonth"),
          query: "month",
        } /*,
        {
          title: this.$t("statsModeYear"),
          query: "year",
        },*/,
      ],
    };
  },
  computed: {
    getSizerWidth() {
      let tmp;
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          tmp = this.$vuetify.breakpoint.width - 30;
          break;
        case "sm":
          tmp = this.$vuetify.breakpoint.width - 30;
          break;
        case "md":
          tmp = 800;
          break;
        case "lg":
          tmp = 1000;
          break;
        case "xl":
          tmp = 1200;
          break;
      }
      return tmp;
    },
  },
  methods: {
    selectMode() {
      if (this.cMode == "day") {
        this.getDayView(new Date());
      } else if (this.cMode == "month") {
        this.getMonthView(new Date());
      } else if (this.cMode == "year") {
        console.log(this.dayView);
      }
    },
    changeView(num) {
      if (this.cMode == "day") {
        if (num == -1 && this.dayView.month == 0) {
          this.dayView.month = 11;
          this.dayView.year--;
        } else if (num == 1 && this.dayView.month == 11) {
          this.dayView.month = 0;
          this.dayView.year++;
        } else this.dayView.month += num;

        this.getDayView(new Date(this.dayView.year, this.dayView.month, 1));
      } else if (this.cMode == "month") {
        this.dayView.year += num;
        this.getMonthView(new Date(this.dayView.year, 0, 1));
      } else if (this.cMode == "year") {
        console.log(this.cMode);
      }
    },
    selectView() {
      if (this.cMode == "day") {
        this.getDayView(new Date(this.dayView.year, this.dayView.month, 1));
      } else if (this.cMode == "month") {
        this.getMonthView(new Date(this.dayView.year, 0, 1));
      }
    },
    async getDayView(date) {
      this.$refs.statsChart.updateOptions({
        xaxis: {
          labels: {
            format: "dd",
          },
        },
      });

      this.dayView.from = new Date(
        date.getFullYear(),
        date.getMonth(),
        1,
        1,
        0,
        0
      );
      this.dayView.to = new Date(
        date.getFullYear(),
        date.getMonth() + 1,
        1,
        0,
        0
      );
      this.dayView.month = date.getMonth();
      this.dayView.year = date.getFullYear();

      await this.$store.dispatch("getOrderFullMonthDays", {
        client: this.$store.state.storeClient.client.basicSettings.name,
        digits: this.$store.state.storeClient.client.environmentSettings.digits,
        labelImageOrder: this.$t("statsDevelopImagesTitle"),
        labelGiftOrder: this.$t("statsPhotoItemsTitle"),
        labelExtraCosts: this.$t("statsExtraCostsTitle"),
        from: this.dayView.from,
        to: this.dayView.to,
      });
    },
    async getMonthView(date) {
      this.$refs.statsChart.updateOptions({
        xaxis: {
          type: "datetime",
          labels: {
            format: "MM",
          },
        },
      });

      this.dayView.from = new Date(date.getFullYear(), 0, 1, 0, 0);
      this.dayView.to = new Date(date.getFullYear(), 12, 1, 0, 0);
      this.dayView.month = date.getMonth();
      this.dayView.year = date.getFullYear();

      await this.$store.dispatch("getOrderFullYearMonths", {
        client: this.$store.state.storeClient.client.basicSettings.name,
        digits: this.$store.state.storeClient.client.environmentSettings.digits,
        labelImageOrder: this.$t("statsDevelopImagesTitle"),
        labelGiftOrder: this.$t("statsPhotoItemsTitle"),
        labelExtraCosts: this.$t("statsExtraCostsTitle"),
        from: this.dayView.from,
        to: this.dayView.to,
      });
    },
  },
  mounted() {
    this.$store.state.storeOrderDayFull.orderStats = [];
    this.cMode = "day";
    this.getDayView(new Date());
  },
  created() {
    // dopolnimo seznam za iskanje po letih od 2020 do now()
    if (new Date().getFullYear() > 2020)
      for (let i = 2021; i <= new Date().getFullYear(); i++) {
        this.yearsType.push({
          query: i,
        });
      }
  },
};
</script>